import { Component, OnInit, Input } from '@angular/core';
import { CertificateService } from '../../../certificates/services/certificate.service';
import { ParametersService } from '../../../core/services/parameters.service';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() showEditButton: boolean;
  @Input() editionRoute: any[];
  @Input() editButtonText: string;

  constructor(
    public certificateService: CertificateService,
    private parameterService: ParametersService
    ) { }

  ngOnInit() {
  }

  isSameCountry() {
    return this.certificateService.selectedCertificate.country.code === this.parameterService.country.code;
  }

}
